module.exports = __webpack_public_path__ + "img/Menu-18.75191318.webp";